import React, { useState } from 'react';
import Icon from 'shared-assets/components/Icon';
import ModalControl from 'shared-assets/facesheet-ui/components/ProtectedPatientChart/ChartAccess/ModalControl';
import { Button, Typography } from '@kareo/design-system';

export default function AccessLink({
  linkLabel,
  protectionSettings,
  userChartAccess,
  togglePatientRestriction,
  patientId,
  firstName,
  lastName,
  style,
  cachedChartAccessContext,
}) {
  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(prev => !prev);
  };

  return (
    <>
      <Button
        variant="text"
        startIcon={
          <Icon
            type={linkLabel === 'Unrestricted' ? 'unlock-icon' : 'lock-icon'}
            size={1}
          />
        }
        color="vitality"
        onClick={toggleModal}
        style={style || undefined}
      >
        <Typography component="div">{linkLabel}</Typography>
      </Button>
      <If condition={showModal}>
        <ModalControl
          open={showModal}
          toggleModal={toggleModal}
          modalRolePath={protectionSettings.modalRolePath}
          patientRestricted={userChartAccess.patientRestricted}
          userAccess={userChartAccess.userAccessLinked}
          patientId={patientId}
          dataRestrictionEnabled={
            userChartAccess?.clinicalDataAccessRestrictionEnabled &&
            userChartAccess?.chartAccessRestrictionEnabled
          }
          togglePatientRestriction={togglePatientRestriction}
          legacy={false}
          firstName={firstName}
          lastName={lastName}
          cachedChartAccessContext={cachedChartAccessContext}
        />
      </If>
    </>
  );
}
